import { memo, useState } from 'react'
import { Tooltip } from '@material-ui/core'

import Active from '../../commons/Active'
import Inactive from '../../commons/Inactive'
import TableCell from '../../commons/TableCell'
import ResultsTable from '../../ResultsTable'
import ActiveLink from './components/AppImage/AppImage'
import UploadManual from './components/UploadManual/UploadManual'

import { OPERACIONES_APLICACIONES, VALUES } from 'utils/constants'
import { applicationsStyles } from './styles'
import pdfOut from '../../../images/icons/pdfOut.svg'
import pdfUp from '../../../images/icons/pdfUp.svg'
import { useHasOperation } from 'hooks/useHasOperation'

const ApplicationTable = ({
   isSearch,
   order,
   searchApplications,
   applications,
   actionEdit,
   cleanCallback,
   setTextError,
   setShowError,
   setConfirmAlertStatus,
   actionSubmit,
   customActions
}) => {
   const VER_CODIGO_APLICACION = useHasOperation(OPERACIONES_APLICACIONES.VER_CODIGO_APLICACION)
   const CARGAR_MANUAL_APPLICACION = useHasOperation(OPERACIONES_APLICACIONES.CARGAR_MANUAL_APLICACION)

   const columns = [
      {
         title: 'NOMBRE APLICACIÓN',
         field: 'name',
         align: 'center',
         sorting: !!isSearch,
         customSort: () => 0,
         defaultSort: order,
         render: rowData => <TableCell text={rowData?.name} />
      },
      {
         title: 'ENLACE APLICACIÓN',
         field: 'link',
         sorting: false,
         align: 'center'
      },
      {
         title: 'TIPO APLICACIÓN',
         field: 'type',
         sorting: false,
         align: 'center',
         render: rowData => VALUES.APPLICATION_TYPE_OPTIONS.find(appTypeOpt => appTypeOpt.value === rowData.type).label
      },
      {
         title: 'ESTADO APLICACIÓN',
         field: 'status',
         align: 'center',
         sorting: false,
         render: rowData => (rowData?.status === 'A' ? <Active /> : <Inactive />)
      },
      {
         title: 'NOMBRE SUBDOMINIO',
         field: 'subdomain.name',
         sorting: false,
         align: 'center',
         render: rowData => <TableCell text={rowData?.subdomain?.name} />
      },
      {
         title: 'ICONO MUNDO MUTUAL',
         field: 'description',
         align: 'center',
         sorting: false,
         render: rowData => <ActiveLink rowData={rowData} />
      },
      {
         title: 'FECHA REGISTRO',
         field: 'createdDate',
         sorting: false,
         align: 'center'
      },
      {
         title: 'USUARIO REGISTRO',
         field: 'createdBy',
         sorting: false,
         align: 'center'
      }
   ]

   const [loadPdf, setLoadPdf] = useState({})
   const classes = applicationsStyles()

   const handlePdf = rowData => {
      const newRowData = {
         ...rowData,
         manualActive: Boolean(rowData?.manual)
      }
      setLoadPdf(newRowData)
   }

   const tableActions = [
      ...customActions,
      ...(CARGAR_MANUAL_APPLICACION
         ? [
              rowData => ({
                 icon: () => <IconPdf rowData={rowData} handlePdf={handlePdf} />
              })
           ]
         : [])
   ]

   return (
      <>
         {loadPdf && (
            <div className={classes.formContainerStyles}>
               <UploadManual
                  loadPdf={loadPdf}
                  setLoadPdf={setLoadPdf}
                  applications={applications}
                  setTextError={setTextError}
                  setShowError={setShowError}
                  setConfirmAlertStatus={setConfirmAlertStatus}
                  actionSubmit={actionSubmit}
               />
            </div>
         )}
         <ResultsTable
            columns={columns}
            tableData={applications}
            isSearch={isSearch}
            searchCallback={searchApplications}
            cleanCallback={cleanCallback}
            customActions={tableActions}
            actionEdit={actionEdit}
            order={order}
            enableKey={VER_CODIGO_APLICACION}
         />
      </>
   )
}

const IconPdf = ({ rowData, handlePdf }) => {
   return (
      <Tooltip arrow title={rowData?.manual ? 'Ver manual' : 'Subir manual'} onClick={() => handlePdf(rowData)}>
         <img src={rowData?.manual ? pdfUp : pdfOut} alt="" />
      </Tooltip>
   )
}

export default memo(ApplicationTable)
